import('./menu_item.scss')


export default function MenuItem(opts={}){
    
    BaseConstructor.call(this)
    let {id, title, icon, closeIcon} = opts
    let elements = {}
    let context = this
    let offcanvasComponent

    this.getElement = () =>{
        return elements.container
    }

    this.active = () =>{
        $(elements.container).addClass('active')
        $(elements.title).html('')
        $(elements.icon).html(closeIcon)
    }
    this.disable = () =>{
        $(elements.container).removeClass('active')
        $(elements.title).html(title)
        $(elements.icon).html(icon)
    }

    init()
    
    
    function init(){

        elements.container = context.createElement('div', 'sidebar-menu-item-container')
        $(elements.container).append(generateContent())
        
        $(elements.container).on('click', _=>{
            context.trigger('click', id)
        })

    }

    function generateContent(){
        elements.title = context.createElement('div', 'menu-item-title', title)
        elements.icon = context.createElement('div', 'menu-item-icon', icon)

        $(elements.container).append(elements.title, elements.icon)
    }
}

MenuItem.prototype = Object.create(BaseConstructor.prototype)